import { createContext, useCallback, useContext, useState } from "react";
import axios from "../api/axios";
import { APIS } from "../api";
import { toast } from "react-toastify";
import { handleNavigationError } from "../api/error";
import { useNavigate } from "react-router-dom";
import { componentRoutes } from "../constants/componentRoutes";

export const MetaContext = createContext({
    pages: [],
    metaInfo: [],
    metaLoader: false,
    onLoadPages: async () => { },
    onLoadMetaInfo: async () => { },
    onAddMetaInfo: async (values) => { },
    onUpdateMetaInfo: async (values) => { },
    onDeleteMetaInfo: async (values) => { }
});

export const MetaProvider = ({ children }) => {

    const [pages, setPages] = useState(null);
    const [metaInfo, setMetaInfo] = useState(null);
    const [metaLoader, setMetaLoader] = useState(false);

    const navigate = useNavigate();

    const onLoadPages = useCallback(
        async () => {
            setMetaLoader(true);
            try {
                const { data } = await axios.post(APIS.PAGE_LIST);
                if (data.code == 1) {
                    setPages(data?.data);
                } else {
                    setPages([]);
                }
                setMetaLoader(false);
            } catch (error) {
                handleNavigationError(navigate, error);
            } finally {
                setMetaLoader(false);
            }
        },
        [navigate]
    );

    const onLoadMetaInfo = useCallback(
        async () => {
            setMetaLoader(true)
            try {
                const { data } = await axios.post(APIS.LIST_META_INFO);
                if (data.code == 1) {
                    setMetaInfo(data?.data);
                } else {
                    setMetaInfo([]);
                }
                setMetaLoader(false);
            } catch (error) {
                handleNavigationError(navigate, error);
            } finally {
                setMetaLoader(false);
            }
        },
        [navigate]
    );

    const onAddMetaInfo = useCallback(
        async (values) => {
            setMetaLoader(true)
            try {
                const { data } = await axios.post(APIS.EDIT_META_TAG, values);
                if (data.code == 1) {
                    toast.success(data.message);
                } else {
                    toast.error(data.message);
                }
                setMetaLoader(false)
                await onLoadMetaInfo();
                navigate(componentRoutes.metaInfo);
            } catch (error) {
                handleNavigationError(navigate, error);
            } finally {
                setMetaLoader(false)
            }
        },
        [onLoadMetaInfo, navigate]
    );

    const onUpdateMetaInfo = useCallback(
        async (values) => {
            setMetaLoader(true)
            try {
                const { data } = await axios.post(APIS.EDIT_USER, values);
                if (data.code == 1) {
                    // navigate(componentRoutes.blog);
                    toast.success(data.message)
                } else {
                    toast.error(data.message);
                }
                setMetaLoader(false)
                // await onLoadMetaInfo();
            } catch (error) {
                handleNavigationError(navigate, error);
            } finally {
                setMetaLoader(false)
            }
        },
        [onLoadMetaInfo, navigate]
    );

    const onDeleteMetaInfo = useCallback(
        async (values) => {
            setMetaLoader(true)
            const payload = {
                tag_id: values
            }
            try {
                const { data } = await axios.post(APIS.DELET_META_TAG, payload);

                if (data.code == 1) {
                    toast.success(data.message);
                }
                setMetaLoader(false);
                // await onLoadMetaInfo();
                return data;
            } catch (error) {
                handleNavigationError(navigate, error);
            } finally {
                setMetaLoader(false)
            }
        }, [onLoadMetaInfo, navigate]);

    const values = {
        pages,
        metaInfo,
        metaLoader,
        onLoadPages: useCallback(
            async () => {
                return await onLoadPages();
            },
            [onLoadPages]
        ),
        onLoadMetaInfo: useCallback(
            async () => {
                return await onLoadMetaInfo();
            },
            [onLoadMetaInfo]
        ),
        onAddMetaInfo: useCallback(
            async (values) => {
                return await onAddMetaInfo(values);
            },
            [onAddMetaInfo]
        ),
        onUpdateMetaInfo: useCallback(
            async (values) => {
                return await onUpdateMetaInfo(values);
            },
            [onUpdateMetaInfo]
        ),
        onDeleteMetaInfo: useCallback(
            async (values) => {
                return await onDeleteMetaInfo(values);
            },
            [onDeleteMetaInfo]
        ),
    };

    return (
        <MetaContext.Provider value={values}>
            {children}
        </MetaContext.Provider>
    );
};

export const useMeta = () => useContext(MetaContext);